/**
 * @prettier
 * @flow
 */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import type { PaymentLinkVm } from 'src/types/PaymentLinkVm';
import { translate } from 'src/utils/translate/translate';

export function PaymentLinkIsPaid({ paymentLink }: Props) {
    const classes = useStyles();
    return (
        <Grid container direction='row' justify='center' alignItems='center' className={classes.container}>
            <div className={classes.paper}>
                <Typography variant='h4' align='center' color='textSecondary'>
                    {translate('Thank you, the payment has been successful')}
                </Typography>
                <Typography variant='subtitle1' align='center' className={classes.header} color='textSecondary'>
                    {translate('Please contact @company for any questions regarding your payment.', { company: paymentLink?.companyName })}
                </Typography>
            </div>
        </Grid>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
    },
}));

type Props = {
    paymentLink?: PaymentLinkVm,
};
